import { ApiService } from "./api";

 type TemplateResponse = {
  success: boolean;
  data: {
    templateId: number;
  };
  message: string;
  version: string;
  meta: Record<string, any>;
};
 export class TemplateService {
  private static ENDPOINT = "/settings/widget-email-template";

  static async listAll(token: string) {
    return await ApiService.get<TemplateResponse>(`${this.ENDPOINT}`, token);
  }

  static async getById(templateId: number, token: string) {
    return await ApiService.get<any>(`/mobile/templates/${templateId}`, token);
  }
}